import { FC, useCallback, useState } from 'react';

import FormElement from '@formstack/phoenix/components/FormGroup/FormElement';

import { ConfirmationDialog } from '@/common/components/ConfirmationDialog/ConfirmationDialog';
import { StyledLabel } from '@/common/components/Layout';
import { useResource } from '@/common/resources';

export type DisconnectAppDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DisconnectAppDialog: FC<DisconnectAppDialogProps> = ({
  open = false,
  onConfirm,
  onCancel,
}) => {
  const resource = useResource((resource) => resource.APP_CONNECTIONS.DISCONNECT_APP_DIALOG);

  const [acknowledged, setAcknowledged] = useState(false);
  const onAcknowledgedInputChange = useCallback(
    () => setAcknowledged(!acknowledged),
    [acknowledged, setAcknowledged]
  );
  const onConfirmInternal = useCallback(() => {
    onConfirm();
    setAcknowledged(false);
  }, [onConfirm, setAcknowledged]);
  const onCancelInternal = useCallback(() => {
    onCancel();
    setAcknowledged(false);
  }, [onCancel, setAcknowledged]);

  return (
    <ConfirmationDialog
      id="disconnect-app-dialog"
      open={open}
      heading={resource.heading}
      message={
        <div>
          {resource.message}
          <br />
          <br />
          <FormElement>
            <StyledLabel>
              <input type="checkbox" checked={acknowledged} onChange={onAcknowledgedInputChange} />
              {resource.confirmationCheckboxLabel}
            </StyledLabel>
          </FormElement>
        </div>
      }
      confirmLabel={resource.confirmationActionLabel}
      confirmDisabled={!acknowledged}
      onConfirm={acknowledged ? onConfirmInternal : undefined}
      onCancel={onCancelInternal}
    />
  );
};
